

import { h, render, Component } from 'preact';
import { Wizard } from '../wizard';

export class InfoSmsActivate extends Component {

  constructor(props) {
    super(props);

    this.state = {
      sending: false,
      sent: false,
      status: 'waiting'
    }
    
  }

  smsActivate = e => {
    this.setState({sending:true})
    var me = this;

    fetch("/api/v1/enroll/sms-activate")
    .then( resp => {
      if(resp.ok) {
        me.setState({
          sending:false,
          sent: true
        })
        me.poll_enroll_status();
      } else {
        this.setState({submitted:false})
      }
    });
  }

  poll_enroll_status = () => {
    var me = this;
    setTimeout(function() {
      me.fetch_enroll_status()
        .then( data => {
          if(data.response != "waiting") {
            me.props.next();
          } else {
            me.poll_enroll_status();
          }
        });
    }, 3000);
  }

  fetch_enroll_status = () => {
    return fetch(
      "/api/v1/enroll/status"
    ).then( resp => {
      return resp.json();
    });
  }

  render(props, state) {
		return (
      <Wizard isPanel={true}
        title={"Activate "+props.formattedPhoneNumber}
        prev={{callback: props.prev}}
        next={{callback: this.smsActivate, disabled: state.sent||state.sending, label: state.sent?"Awaiting Activation":"Text me a link"}}>
        <p>We need to send your device a unique activation code. When you are ready, we will text the number you provided with a unique link. Once you have clicked the link, and your device is activated, you will be automatically redirected to complete your authentication.</p>
      </Wizard>
		)
  }
}
